import { useContext, useState, useEffect } from "react";

import { useTheme } from "@mui/system";
import { useThemeContext } from "themes/CustomThemeProvider";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import WbSunnyRoundedIcon from "@mui/icons-material/WbSunnyRounded";
import ModeNightRoundedIcon from "@mui/icons-material/ModeNightRounded";

function ToggleColorMode() {
  const [mode, setMode] = useState("light");

  const theme = useTheme();

  const colorMode = useThemeContext();

  useEffect(() => {
    setMode(theme.palette.mode);
  }, [theme.palette.mode]);

  return (
    <Box sx={{ maxWidth: "32px" }}>
      <Button
        variant="text"
        onClick={colorMode.toggleColorMode}
        size="small"
        aria-label="button to toggle theme"
        sx={{ minWidth: "32px", height: "32px", p: "4px" }}
      >
        {mode === "dark" ? (
          <WbSunnyRoundedIcon fontSize="small" />
        ) : (
          <ModeNightRoundedIcon fontSize="small" />
        )}
      </Button>
    </Box>
  );
}

export default ToggleColorMode;
